(() => {
  angular
    .module('complianceFrameworkApp')
    .constant('assessmentEvents', assessmentEvents())
    .constant('assessmentFrequencies', assessmentFrequencies())
    .constant('contractEvents', contractEvents())
    .constant('contractStatuses', contractStatuses())
    .constant('documentRequirementEvents', documentRequirementEvents())
    .constant('reportNames', reportNames())
    .constant('reportFormats', reportFormats())
    .constant('riskLevels', riskLevels())
    .constant('vendorStatuses', vendorStatuses());

  function assessmentEvents() {
    return ['Expiring Risk Assessment'];
  }

  function assessmentFrequencies() {
    return [
      {
        'label': '3 months',
        'value': 3
      },
      {
        'label': '6 months',
        'value': 6
      },
      {
        'label': '12 months',
        'value': 12
      },
      {
        'label': '24 months',
        'value': 24
      },
      {
        'label': '36 months',
        'value': 36
      }
    ];
  }

  function contractEvents() {
    return ['Contract Expiration', 'Contract Renewal'];
  }

  function contractStatuses() {
    return [
      {
        'label': 'Active',
        'value': 'Active'
      },
      {
        'label': 'Inactive',
        'value': 'Inactive'
      }
    ];
  }

  function documentRequirementEvents() {
    return ['Expiring Document', 'Missing Document'];
  }

  function reportFormats() {
    return ['html', 'pdf', 'csv'];
  }

  function reportNames() {
    return [
      {
        'label': 'Assigned Tasks',
        'value': 'assigned_tasks'
      },
      {
        'label': 'Contract Detail',
        'value': 'contract_detail'
      },
      {
        'label': 'Expired And Renewing Contracts',
        'value': 'expired_and_renewing_contracts'
      },
      {
        'label': 'Expiring And Missing Documents',
        'value': 'expiring_and_missing_documents'
      },
      {
        'label': 'Expiring Risk Assessments',
        'value': 'expiring_risk_assessments'
      },
      {
        'label': 'Risk Detail',
        'value': 'risk_detail'
      },
      {
        'label': 'Risk Overview',
        'value': 'risk_overview'
      },
      {
        'label': 'Vendor Detail',
        'value': 'vendor_detail'
      }
    ];
  }

  function riskLevels() {
    return [
      {
        'label': 'Major',
        'value': 2
      },
      {
        'label': 'Mission Critical',
        'value': 1
      },
      {
        'label': 'Mission Critical - Cloud Computing',
        'value': 4
      },
      {
        'label': 'Mission Critical - IT',
        'value': 5
      },
      {
        'label': 'Mission Critical - Core',
        'value': 7
      },
      {
        'label': 'Non-Critical',
        'value': 3
      }
    ];
  }

  function vendorStatuses() {
    return [
      {
        'label': 'Active',
        'value': 'active'
      },
      {
        'label': 'Inactive',
        'value': 'inactive'
      },
      {
        'label': 'Potential',
        'value': 'potential'
      }
    ];
  }
})();
